/**
 * 文件功能：路由配置文件（英语单词消消乐独立版，Vue Router 4）
 * 输入参数：无（读取游戏组件定义路由表）
 * 输出参数：导出 router 实例供 main.ts 注册
 * 返回值：Router 实例
 * 说明：history 模式路由。"/" 为游戏布局容器（底部 Tab 导航 + 子路由视图），
 *       子路由：''（首页消消乐）/ ranking（排行榜）/ profile（个人中心）；
 *       "/login" 为学生登录页（独立顶层路由，不显示底部导航）。
 */
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import EnglishGamePage from '../components/EnglishGamePage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'game',
    component: EnglishGamePage,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('../components/EnglishIndexPage.vue'),
      },
      {
        path: 'ranking',
        name: 'ranking',
        component: () => import('../components/EnglishRankingPage.vue'),
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('../components/EnglishProfilePage.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/StudentLoginPage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
